<template>
  <div class="diagram-actions">
    <div
      role="button"
      tabindex="0"
      class="btn-container-bottom captures-description"
      @click="!$store.state.isWorkflowDisabled && $emit('add-lane')"
      :class="{ 'disabled': $store.state.isWorkflowDisabled }"
    >
      <v-icon size="small">mds:add</v-icon>
      Add lane
    </div>

    <div
      v-if="hasEvents"
      role="button"
      tabindex="0"
      class="btn-container-bottom captures-description"
      @click="!$store.state.isWorkflowDisabled && $emit('add-shape', {}, { parentEventId: 'start', createNewLaneIfNoLaneId: true })"
      :class="{ 'disabled': $store.state.isWorkflowDisabled }"
    >
      <v-icon size="small">mds:add</v-icon>
      Add start point
    </div>

    <v-tooltip location="bottom" max-width="220" open-delay="500" v-if="hasEvents">
      <template v-slot:activator="{ props }">
        <div
          role="button"
          tabindex="0"
          class="btn-container-bottom captures-description"
          @click="!$store.state.isWorkflowDisabled && $emit('add-group', selectedEventId)"
          :class="{ 'disabled': $store.state.isWorkflowDisabled }"
          v-bind="props"
        >
          <v-icon size="small">mds:add</v-icon>
          Add group
        </div>
      </template>
      <div>
        <p>
          Click here to add a new group. After adding 2 groups you will get a vertical divider that you can move sideways.
        </p>
      </div>
    </v-tooltip>
    <div
      v-if="hasEvents"
      role="button"
      class="btn-container-bottom"
      @click="!$store.state.isWorkflowDisabled ? openWorkflowFromCodeDialog = true : undefined"
      :class="{ 'disabled': $store.state.isWorkflowDisabled }"
    >
      <v-icon size="small" icon="mdi-github" />
      Generate from code
    </div>
    <workflow-from-code
      :modelValue="openWorkflowFromCodeDialog"
      @update:modelValue="(val) => openWorkflowFromCodeDialog = val"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { diagramHelpers } from '@/mixins/diagramHelpers'
import WorkflowFromCode from '@/components/WorkflowFromCode.vue'

export default {
  components: { WorkflowFromCode },
  mixins: [diagramHelpers],

  props: {
    selectedEvent: Object,
    cardTypes: Array,
    baseData: Object,
    svgGraph: Object,
    svgGroups: Object,
    svgLanes: Object
  },

  data: () => ({
    commentsDialog: false,
    commentsDialogVote: null,
    feedbackDialog: false,
    openWorkflowFromCodeDialog: false
  }),

  computed: {
    ...mapState({ workflow: state => state.workflow.workflow }),
    selectedEventId () {
      return this.$route.params.eventId
    },
    hasEvents () {
      return this.workflow?.domainEvents && this.workflow.domainEvents.length
    }
  }
}
</script>

<style scoped>
.v-tooltip__content {
  background: var(--light-1);
  color: var(--color-primary);
  border-radius: 10px;
}

.v-tooltip__content code {
  background: var(--color-primary);
  color: white;
}

.captures-description:focus-visible {
  outline: none;
}
</style>
